// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"424": "27cfe973928c5867","757": "f53f10e7818c0c2e",}[chunkId] + ".css"
}